import AddNew from "./AddNew";
import Vendors from "./Vendors";

export default { AddNew, Vendors };
